export default "__VITE_ASSET__CkkcK9a___"